import React, { Component, PropTypes } from 'react';
import { Toggle } from 'material-ui';
import Icon from './icon';

const isLeft = (evt) => {
  const width = evt.target.offsetWidth;
  let el = evt.target;
  let x = 0;

  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    el = el.offsetParent;
  }

  x = evt.clientX - x;

  return width / 2 > x;
};

class Rating extends Component {

  constructor(props) {
    super(props);
    const rating = props.rating || {};
    this.state = {
      hoverIndex: rating.value,
    };
    this._toggleType = this._toggleType.bind(this);
  }

  _updateStars = (startValue, event) => {
    if (!this.props.isEditing) return;
    const value = isLeft(event) ? startValue - 0.5 : startValue;
    this.props._updateSubField('value', value);
  };

  _startHover = (hoverIndex, event) => {
    if (!this.props.isEditing) return;
    const value = isLeft(event) ? hoverIndex - 0.5 : hoverIndex;
    this.setState({
      hoverIndex: value,
    });
  };

  _clearStarHover = () => {
    if (!this.props.isEditing) return;
    this.setState({
      hoverIndex: this.props.rating.value,
    });
  };

  _toggleType = () => {
    const type = this.props.rating.type === 'Self-Assessed' ?
      'Certified Official Rating (ie Australian STAR Rating, New Zealand Qualmark Rating, etc.)' :
      'Self-Assessed';
    this.props._updateSubField('type', type);
  };

  render() {
    const stars = [];
    const certifiedLongText = 'Certified Official Rating (ie Australian STAR Rating, New Zealand Qualmark Rating, etc.)';
    let value;
    let type;
    let inlineStyleWithMargin;
    let inlineStyle = {};
    if (this.props.isEditing) {
      value = this.state.hoverIndex;
      type = (
        <Toggle
          checked={this.props.rating.type !== 'Self-Assessed'}
          label={certifiedLongText}
          labelPosition="right"
          style = {{
            cursor: 'pointer',
            overflow: 'visible',
            width: '100%',
            verticalAlign: 'middle',
          }}
          onToggle={this._toggleType}
          name="toggleName1"
          value="toggleValue1"
        />
      );
    } else {
      inlineStyle = { display: 'inline-block' };
      inlineStyleWithMargin = { display: 'inline-block', marginRight: '8px' };
      value = this.props.rating ? this.props.rating.value : undefined;
      type = (() => {
        if (this.props.rating) {
          if (this.props.rating.type === certifiedLongText) return 'Certified Rating';
          return this.props.rating.type;
        }
      })();
    }
    let i = 1;
    while (i < 6) {
      let starClass = '';
      if (i <= value) {
        starClass = 'tc-icon-star';
      } else if (value > i - 1) {
        starClass = 'tc-icon-star-half';
      } else if (this.props.isEditing) {
        starClass = 'tc-icon-star-empty';
      } else {
        break;
      }
      stars.push(<Icon key={i} className={starClass} onClick={this._updateStars.bind(this, i)} onMouseMove={this._startHover.bind(this, i)} onMouseOut={this._clearStarHover}/>);
      i++;
    }

    return (
      <div style={Object.assign(inlineStyle, this.props.style)}>
        <div style={inlineStyleWithMargin}>
          {stars}
        </div>
        <div style={inlineStyle}>
          {type}
        </div>
      </div>
    );
  }

}

Rating.propTypes = {
  rating: PropTypes.object,
  isEditing: PropTypes.bool,
  style: PropTypes.object,
  _updateSubField: PropTypes.func,
};

export default Rating;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/rating.jsx